exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky{position:sticky;top:0;padding:20px;z-index:99;background-color:#fff}.europeanaItems{top:100px}.europeanaAlert{margin-top:10px}#itemDescription{text-align:justify;text-justify:inter-word;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ea6e1e7","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/search/EuropeanaSearch.vue
// module id = 694
// module chunks = 0